import { DyTemplateCardProps } from './DyTemplateCard.interface';
import {
  TemplateContainer,
  TemplateSubtitle,
  TemplateTitle,
} from './DyTemplateCard.styled';
import { formatDescription } from './DyTemplateCard.utils';

export const DyTemplateCard = ({
  template,
  isSelected,
  onClicked,
}: DyTemplateCardProps) => {
  const formattedDescription = template.description
    ? formatDescription(template.description)
    : null;

  return (
    <TemplateContainer $isSelected={isSelected} onClick={onClicked}>
      <TemplateTitle>{template.template_name.replace('_', ' ')}</TemplateTitle>
      {formattedDescription && (
        <TemplateSubtitle>{formattedDescription}</TemplateSubtitle>
      )}
    </TemplateContainer>
  );
};
